import escape from 'lodash/escape';
import customfn from "@/_functions.js";
import clp from "@/_clp.js";

$(function () {
    if($(document).find('.company-dashboard, .company-office').length){

        var myEvent = window.attachEvent || window.addEventListener;
        var chkevent = window.attachEvent ? 'onbeforeunload' : 'beforeunload'; /// make IE7, IE8 compitable

        myEvent(chkevent, function(e) { // For >=IE7, Chrome, Firefox
            // Check the save action is shown
            if($(document).find('.save-item-company-access').is(":visible")) {
                var confirmationMessage = 'Are you sure you want to leave the page before the changes are saved?';
                (e || window.event).returnValue = confirmationMessage;
                return confirmationMessage;
            }
        });
    }

    // Show or hide the the regus staff
    $(document).on('click', 'a.companies-show-staff', function(ev){
        ev.preventDefault();

        $(document).find('.regus-centre-staff').toggle('slow');

        if( $(this).find('i.fa').hasClass('fa-arrow-down')){
            $(this).find('.updowntext').text($(this).data('show-less-text'));
            $(this).find('i.fa').removeClass('fa-arrow-down').addClass('fa-arrow-up');
        }
        else{
            $(this).find('.updowntext').text($(this).data('show-more-text'));
            $(this).find('i.fa').removeClass('fa-arrow-up').addClass('fa-arrow-down');
        }

    })

    // Open the assign tags screen
    $(document).on('click', 'button.assign-tags-to-company', function(ev){
        ev.preventDefault();
        var url = $(this).attr('href');
        customfn.getModal(url, $(this));
    });

    // If enter is hit in the form, check the status of the filled in tag
    $(document).on('keyup', 'form#assign_tag_number .tag-input', function (ev){
        ev.preventDefault();
        var tag_number = $(this).val();
        var maxLength = (typeof $(this).attr('maxlength') != 'undefined') ? $(this).attr('maxlength') : 4;

        if((ev.which == 13 && tag_number.length > 0) || tag_number.length == maxLength)  {
            // Try to get the status of the tag
            customfn.registerTag($(this));
        }

        return false;
    })
    $(document).on('submit', 'form#assign_tag_number', function (ev){
        ev.preventDefault();
        return false;
    });

    $(document).on('click', '.save-assigned-buttons', function(ev){
        ev.preventDefault();

        var url = $(this).attr('href');
        customfn.postModal(url, $('form#assign_tag_number').serialize());
    })

    $(document).on('click', 'a.unassign-tag', function(ev){
        ev.preventDefault();

        customfn.unAssignTag($(this).closest('.assigned-tag'));
    });

    $(document).on('click', 'a.unassign-all-tags', function(ev){
        ev.preventDefault();
        // Get the rows of the assigned tags and trigger the click
        var links = $(document).find('a.unassign-tag');
        $.each(links, function(index, value){
           $(this).trigger('click');
        });
    });

    // Block/unblock the tag from the tag overview
    $(document).on('click', '.company-user-overview-block', function(ev){
        ev.preventDefault();
        var $ClickedButton = $(this);
        $ClickedButton.next('.spinner').show();
        $ClickedButton.hide();
        $ClickedButton.parent().find('p.error-box').hide();

        var typeAction = $(this).data('type-action');
        var url = $(this).attr('href');

        var formFields = [];
        formFields.push({name: "_token", value: $(document).find('input[name="_token"]').val()});
        formFields.push({name: "action", value: typeAction});
        formFields.push({name: "jumbotron", value: (($ClickedButton.closest('.jumbotron').length))});

        $.ajax(url, {
            method: "POST",
            data: $.param(formFields),
            success : function(data){

                if(data.status &&
                    data.status == 1) {
                    if(data.jumbotron){
                        $('.jumbotron-employee').html(data.jumbotron);
                    }
                    else {
                        var $userOverview = $(document).find('#company_team_employees');
                        var url = $userOverview.data('refresh-url');
                        if (typeof url != 'undefined') {
                            $.get(url, function (data) {
                                if (data.html) {
                                    $userOverview.html(data.html);
                                }
                            })
                        }
                        var $tagOverview = $(document).find('#company_tags');
                        var url = $tagOverview.data('refresh-url');
                        if (typeof url != 'undefined') {
                            $.get(url, function (data) {
                                if (data.html) {
                                    $tagOverview.html(data.html);
                                }
                            })
                        }

                        setTimeout(function(){
                            clp.refreshHardware($(document));
                        }, 2000);
                    }
                }
            },
            error : function(jqXHR){
                var data = jqXHR.responseJSON;
                $ClickedButton.next('.spinner').hide();
                $ClickedButton.show();
            }
        });

    });


    // Block/unblock the tag from the tag overview
    $(document).on('click', '.company-tag-overview-blocking, .tag-overview-blocking', function(ev){
        ev.preventDefault();
        var $ClickedButton = $(this);
        $ClickedButton.next('.spinner').show();
        $ClickedButton.hide();

        var typeAction = $(this).data('type-action');
        var url = $(this).attr('href');

        var formFields = [];
        formFields.push({name: "_token", value: $(document).find('input[name="_token"]').val()});
        formFields.push({name: "action", value: typeAction});
        formFields.push({name: "tag_id", value: $(this).data('tag-id')});

        $.ajax(url, {
            method: "POST",
            data: $.param(formFields),
            success : function(data){
                if(data.status &&
                    data.status == 1) {
                    var $tagOverview = $(document).find('#company_tags');
                    var url = $tagOverview.data('refresh-url');
                    if (typeof url != 'undefined') {
                        $.get(url, function (data) {
                            if (data.html) {
                                $tagOverview.html(data.html);
                            }
                        })
                    }
                    var $userOverview = $(document).find('#company_team_employees');
                    var url = $userOverview.data('refresh-url');
                    if (typeof url != 'undefined') {
                        $.get(url, function (data) {
                            if (data.html) {
                                $userOverview.html(data.html);
                            }
                        })
                    }
                    var $accessMethodsOverview = $(document).find('#access-methods-overview');
                    var url = $accessMethodsOverview.data('refresh-url');
                    if (typeof url != 'undefined') {
                        $.get(url, function (data) {
                            if (data.html) {
                                $accessMethodsOverview.html(data.html);
                            }
                        })
                    }
                    setTimeout(function(){
                        clp.refreshHardware($(document));
                    }, 2000);
                }
            },
            error : function(jqXHR){
                var data = jqXHR.responseJSON;
                $ClickedButton.next('.spinner').hide();
                $ClickedButton.show();
            }
        });

    })

    // Block/unblock the device from the device overview
    $(document).on('click', '.company-device-overview-blocking, .device-overview-blocking', function(ev){
        ev.preventDefault();
        var $ClickedButton = $(this);
        $ClickedButton.next('.spinner').show();
        $ClickedButton.hide();

        var typeAction = $(this).data('type-action');
        var url = $(this).attr('href');

        var formFields = [];
        formFields.push({name: "_token", value: $(document).find('input[name="_token"]').val()});
        formFields.push({name: "action", value: typeAction});
        formFields.push({name: "device_id", value: $(this).data('device-id')});

        $.ajax(url, {
            method: "POST",
            data: $.param(formFields),
            success : function(data){
                if(data.status &&
                    data.status == 1) {
                    var $tagOverview = $(document).find('#company_tags');
                    var url = $tagOverview.data('refresh-url');
                    if (typeof url != 'undefined') {
                        $.get(url, function (data) {
                            if (data.html) {
                                $tagOverview.html(data.html);
                            }
                        })
                    }
                    var $userOverview = $(document).find('#company_team_employees');
                    var url = $userOverview.data('refresh-url');
                    if (typeof url != 'undefined') {
                        $.get(url, function (data) {
                            if (data.html) {
                                $userOverview.html(data.html);
                            }
                        })
                    }
                    var $accessMethodsOverview = $(document).find('#access-methods-overview');
                    var url = $accessMethodsOverview.data('refresh-url');
                    if (typeof url != 'undefined') {
                        $.get(url, function (data) {
                            if (data.html) {
                                $accessMethodsOverview.html(data.html);
                            }
                        })
                    }
                    setTimeout(function(){
                        clp.refreshHardware($(document));
                    }, 2000);
                }
            },
            error : function(jqXHR){
                var data = jqXHR.responseJSON;
                $ClickedButton.next('.spinner').hide();
                $ClickedButton.show();
            }
        });
    })

    $(document).on('keyup', '.assign-tags-to-company input[type="text"]', function(){
        var row = $(this).closest('form');

        if(row.find('input.old_data').length > 0) {

            var rowData = [];
            row.find('input[type="text"]').each(function (i, el) {
                rowData.push($(el).val());
            });
            var newData = escape(JSON.stringify(rowData));

            if(newData != row.find('input.old_data').val() && newData != escape(row.find('input.old_data').val())) {
                $(document).find('.assign-tags-to-company').find('input[type="text"]').removeClass('is-invalid');
                $(document).find('.assign-tags-to-company').find('.invalid-feedback').hide().text('');
            }
        }
    });

    /**
     * Reset the device - Start
     */
    $(document).on('click', '.reset-device', function(ev){
        ev.preventDefault();
        var url = $(this).attr('href');
        customfn.getModal(url, undefined, {keyboard: false, backdrop: 'static'});
    });

    $(document).on('click', '.reset-device-save', function(ev){
        ev.preventDefault();

        var form = $(this).closest('form');
        var url = $(this).attr('href');

        // Remove the cancel button
        form.next('button').remove();

        var formFields = [];
        formFields.push({name: "_token", value: $(document).find('input[name="_token"]').val()});
        formFields.push({name: "device_id", value: $(document).find('input[name="device_id"]').val()});

        customfn.postModal(url, formFields);
    });

    /**
     * Reset the device - End
     */

    /**
     * Assign tags by company to user - Start
     */
    $(document).on('click', '.assign-tags-user', function(ev){
        ev.preventDefault();
        var url = $(this).attr('href');
        customfn.getModal(url);
    });

    $(document).on('click', '.user-unassign-tag', function(ev){
        ev.preventDefault();
        var url = $(this).attr('href');
        var formFields = [];
        var $row = $(this).closest('.assigned-tag');
        formFields.push({name: "_token", value: $(document).find('input[name="_token"]').val()});
        formFields.push({name: "tag_id", value: $row.find('input.assigned_tag').val()});

        customfn.postModal(url, formFields);
    })
    /**
     * Assign tags by companies to user - User
     */

    /**
     * Edit the access for a user - Start
     */
    $(document).on('click', '.user-access-edit-item', function(ev){
        ev.preventDefault();
        customfn.editCompanyAccess($(this), 'user');
    })

    // Remove the error box when we click on a checkbox
    $(document).on('click', 'input.has-access', function(ev){
        $(this).closest('div.datagrid-wrapper').find('.error-message').find('p').hide();
    });

    $(document).on('click', 'a.save-item-user-access', function(ev){
        ev.preventDefault();
        customfn.saveAccess($(this), 'user');
    });

    $(document).on('click', '.user-access-edit-item-cancel', function(ev){
        $(this).hide();
        customfn.cancelEditAccess($(this).closest('div[data-type="buttons"]').find('a.btn'), 'user');
    });

    /**
     * Edit the access for a user - End
     */

    /**
     * Edit the access for a user per office - Start
     */
    $(document).on('click', '.office-access-edit-item', function(ev){
        ev.preventDefault();
        customfn.editCompanyAccess($(this), 'office');
    });

    $(document).on('click', 'a.save-item-office-access', function(ev){
        ev.preventDefault();
        customfn.saveAccess($(this), 'office');
    });

    $(document).on('click', '.office-access-edit-item-cancel', function(ev){
        $(this).hide();
        customfn.cancelEditAccess($(this).closest('div[data-type="buttons"]').find('a.btn'), 'office');
    });

    /**
     * Edit the access for a user - End
     */
    $(document).on('click', 'a.save-item-company-access', function(ev){
        ev.preventDefault();
        customfn.saveAccess($(this), 'company');
    });

    $( document ).ajaxComplete(function( event, xhr, settings ) {
        // If the jax request was a sort, check if we are in edit mode
        if(settings.url.substr(0, 5) == '?sort'){
            // Chec kif the cancel button is shown
            if($(document).find('.sub-grid-buttons .cancel-button').is(':visible')){
                customfn.editCompanyAccess($(document).find('a.company-access-edit-item'));
            }
        }
    });

    $(document).on('click', '.company-access-edit-item-cancel', function(ev){
        $(this).hide();
        customfn.cancelEditAccess($(this).closest('div[data-type="buttons"]').find('a.btn'), 'company');
    });

    /**
     * Edit the access for a user - End
     */


    /**
     * Batch assign tags - Start
     */

    $(document).on('click', '#batch-assign-tags', function(ev){
        ev.preventDefault();

        var url = $(this).attr('href');
        customfn.getModal(url);
    });

    /** Block/unblock a companies */
    $(document).on('click', '.blockunblock-company', function(ev){
        ev.preventDefault();

        var $ClickedButton = $(this);

        // Url
        var url = $ClickedButton.attr('href');

        // formfields
        var typeAction = $ClickedButton.data('type-action');
        var formFields = [];
        formFields.push({name: "_token", value: $(document).find('input[name="_token"]').val()});
        formFields.push({name: "action", value: typeAction});

        // Show the spinner
        $ClickedButton.next('.spinner').show();

        // Lets post the block action
        $.ajax(url, {
            method: "POST",
            data: $.param(formFields),
            success : function(data){
                if(data.status && data.status == 1 ){
                    // refresh the page
                    window.location.reload();
                }
            },
            error : function(jqXHR){
                var data = jqXHR.responseJSON;
                if(data.error){

                    $ClickedButton.next().next('p').text(data.error).show();
                }
            }
        }).always(function() {
            $ClickedButton.next('.spinner').hide();
            customfn.resetButtonLoadingState($ClickedButton);
        });
    })

    $(document).on('click', '.save-sync-buttons', function(ev){
        ev.preventDefault();
        let url = $(this).attr('href');
        customfn.postModal(url, $('form#sync_booking_id').serialize());
    })

    $(document).on('click', '.sync-single-booking', function(ev){
        ev.preventDefault();
        let url = $(this).attr('href');
        customfn.getModal(url);
    });
});
